import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdEdit, MdGroupAdd, MdGroups2, MdPersonAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function DiscipleGroupClustersPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [dgClusterData, setDGClusterData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchDGClusterData()
  }, [])

  const fetchDGClusterData = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/dg/clusters/"
    let response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await response.json()
    if (data.status === 200) {
      setDGClusterData(data.data)
    }
    setLoading(false)
  }


  const table_columns = [
    {
      header: "Name",
      accessor: "name"
    },
{
      header: "Cluster Leader",
      accessor: "user_data.first_name"
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]

  return (
    <AdminLayout
      navSelected={"DG Clusters"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>DG Clusters</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/dg/clusters/details?cluster_id=new")
            }}
          >
            <MdAdd size={16} />
            New Cluster
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {dgClusterData.map((cluster, index) => {
            if (!JSON.stringify(cluster).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3>{cluster.name}</h3>
                  <h3 className='card-subtitle'>{cluster?.service_type?.name}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/dg/clusters/details?dg_cluster_id=" + cluster.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
          {/* <pre>{JSON.stringify(dgClusterData, null, 2)}</pre> */}
          <DataTable
            columns={table_columns}
            data={dgClusterData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/dg/clusters/details?dg_cluster_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
